import {
    TextField,
    IconButton
} from '@material-ui/core';
import React, { useEffect, useRef, useState } from 'react';
import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import {
    duplicateField,
    getProjectNameOfField,
    isSystemField,
    onCloseFieldExpandMore,
    removeCurrentGUIAddField,
    getOrgName
} from '@/component/formManagement/handler/FieldListHandler';
import SettingFormDev from '@/component/formManagement/SettingFormDev';
import {
    updateParentFieldList,
    isAddNewField,
    onChangeFieldName,
    isUseFieldInForm,
    isFieldError,
    getErrorByField,
    isEditField,
    isPermissionDeleteField,
    validateAddFieldNameCustom,
    onChangeFieldNameREF,
    isDisplayOptionShareField
} from '../handler/CommonHandler';
import { duplicateField as duplicateFieldInForm } from '@/component/formManagement/handler/FormListHandler';

import ShareField from '../ShareField';
import FieldIdCommon from './FieldIdCommon';
import { useRecoilValue } from 'recoil';
import { projectInuseDetailAtom } from '@/state/atom/projectAtom';
import { corporationAtom } from '@/state/atom/corporationAtom';

export default function AddFieldMermaid(props) {
    // Atom
    const projectInuseDetail = useRecoilValue(projectInuseDetailAtom);
    const corporationDetail = useRecoilValue(corporationAtom);

    // more action popover
    const [moreActionPopover, setMoreActionPopover] = useState(null);

    const indexAddField = Utils.findIndexInArrayById(props.currentAddField.id, props.fieldAddList);

    const [currentFieldData, setCurrentFielData] = useState(props.fieldAddList[indexAddField]);
    const [isUsingProject, setIsUsingProject] = useState(
        Utils.isEmpty(currentFieldData?.usingProjects)
            ? false
            : currentFieldData.usingProjects.includes(props.projectDetail.id)
    );

    const [isUsingForm, setIsUsingForm] = useState(
        Utils.isEmpty(currentFieldData?.isUsingForm) ? false : currentFieldData.isUsingForm
    );

    const fieldRef = useRef('');

    useEffect(() => {
        setCurrentFielData(props.fieldAddList[indexAddField]);
    }, [props.fieldAddList[indexAddField]]);

    const argsAll = {
        ...props,
        indexAddField,
        currentFieldData,
        isUsingProject,
        isUsingForm
    };

    /** handler enter text input name */
    const onEnterTextInputName = event => {
        let textValue = event.target.value;
        let isValidate = validateAddFieldNameCustom(textValue, argsAll);
        // if event diff enter then return
        if (isValidate) {
            if (props.isChangeData === false) props.setIsChangeData(true);
        }
        if (event.key !== 'Enter' || isValidate) {
            return;
        }

        let newName = {
            jp: {
                A: 'F',
                text: textValue
            }
        };

        // reset fieldType selected
        let fieldTypeSelectedList = [...props.fieldTypeSelectedList];
        fieldTypeSelectedList = Utils.removeItemInArrayById(
            props.currentAddField.id,
            fieldTypeSelectedList
        );
        props.setFieldTypeSelectedList(fieldTypeSelectedList);

        props.fieldAddList[indexAddField].name = newName;
        props.fieldAddList[indexAddField].usingProjects = isUsingProject
            ? [props.projectDetail.id]
            : [];
        props.fieldAddList[indexAddField].isUsingProject = isUsingProject;
        props.fieldAddList[indexAddField].isErrorValidate = false;
        props.fieldAddList[indexAddField].isShowInfo = false;

        // update in field list or dragdrop data
        updateParentFieldList(props, currentFieldData, newName, isUsingProject);
    };

    // update ref
    useEffect(() => {
        if (!Utils.isEmpty(currentFieldData) && !Utils.isEmpty(props.fieldRefList)) {
            props.fieldRefList[currentFieldData.id] = fieldRef;
        }
    });

    const handleOnChangeFieldName = (e, args) => {
        let currentFieldDataClone = {...currentFieldData};
        currentFieldDataClone = onChangeFieldNameREF(e, currentFieldDataClone, args);
        setCurrentFielData(currentFieldDataClone);
    }

    const renderCustomField = () => {
        return (
            <li
                id={currentFieldData.id}
                ref={fieldRef}
                className={
                    isUseFieldInForm(currentFieldData, props.formList, argsAll)
                        ? 'listField-li'
                        : 'listField-li background-color-usingForm'
                }
                style={{ width: '100%' }}
            >
                <div
                    className={
                        isUseFieldInForm(currentFieldData, props.formList, argsAll)
                            ? 'fieldSetting-info fieldSetting-info--changeForm'
                            : 'fieldSetting-info fieldSetting-info--changeForm background-color-usingForm'
                    }
                >
                    <div className="fieldSetting-thumb">
                        <img src="/assets/image/mermaid-icon.svg" alt="" />
                    </div>

                    <div className="fieldSetting-cmt">
                        <div className="fieldSetting-name">
                            <div className="formCreate">
                                <TextField
                                    className="form-input-outlined"
                                    placeholder="フィールド名"
                                    onKeyPress={onEnterTextInputName}
                                    onChange={e => handleOnChangeFieldName(e, argsAll)}
                                    defaultValue={Utils.getTextByLanguage(
                                        Constant.LANGUAGE_TYPE.JP,
                                        currentFieldData.name
                                    )}
                                    disabled={!isEditField(currentFieldData, argsAll)}
                                    error={isFieldError('name', currentFieldData)}
                                    helperText={getErrorByField('name', currentFieldData)}
                                    onBlur={e => onChangeFieldName(e, argsAll)}
                                />
                            </div>
                            <p className="fieldSetting-text">
                                {getProjectNameOfField(currentFieldData, props.projectList)}
                            </p>
                            {currentFieldData?.affiliationOrganization !== props.corporationDetail.id && (
                                <p className="fieldSetting-text  --3">
                                    {getOrgName(props?.allListCorp ,currentFieldData?.affiliationOrganization)}
                                </p>
                            )}
                        </div>
                        <div className="fieldSetting-autofill">
                            <div
                                className={
                                    isUseFieldInForm(currentFieldData, props.formList, argsAll)
                                        ? 'fieldSetting-item'
                                        : 'fieldSetting-item background-color-usingForm'
                                }
                            >
                                {!isSystemField(currentFieldData) &&
                                    !isAddNewField(currentFieldData) && (
                                        <>
                                            <IconButton
                                                className="itemTools"
                                                onClick={e => {
                                                    setMoreActionPopover(null);
                                                    if (
                                                        props.parentPanelScreen ===
                                                        Constant.FORM_MANAGEMENT_SCREEN.LIST_FIELD
                                                    ) {
                                                        duplicateField(props, currentFieldData);
                                                    } else if (
                                                        [
                                                            'listFieldAddToForm',
                                                            'listFieldInProject'
                                                        ].includes(props.regionDropIdBlock)
                                                    ) {
                                                        duplicateFieldInForm(
                                                            props,
                                                            currentFieldData,
                                                            props.regionDropIdBlock
                                                        );
                                                    }
                                                    if (props.isChangeData === false) props.setIsChangeData(true);
                                                }}
                                            >
                                                <img src="/assets/image/icon-copy.svg" alt="" />
                                            </IconButton>

                                            {isPermissionDeleteField(
                                                currentFieldData,
                                                props.formList,
                                                argsAll
                                            ) && (
                                                    <IconButton className="itemTools">
                                                        <img
                                                            src="/assets/image/icon-tabs-delete.svg"
                                                            alt=""
                                                            onClick={e => {
                                                                props.handleClick(e);
                                                                props.setCurrentFieldSelected(
                                                                    props.currentAddField
                                                                );
                                                                props.setIsOpenConfirmDeleteModal(
                                                                    true
                                                                );
                                                                props.handleClose();
                                                            }}
                                                        />
                                                    </IconButton>
                                                )}

                                            {!props.disableBtnShowMore && (
                                                <IconButton
                                                    className="itemTools itemTools-arrow"
                                                    onClick={e =>
                                                        onCloseFieldExpandMore(
                                                            props,
                                                            currentFieldData
                                                        )
                                                    }
                                                >
                                                    <img
                                                        src="/assets/image/icon-arrow-accordion-gray.svg"
                                                        alt=""
                                                    />
                                                </IconButton>
                                            )}
                                        </>
                                    )}

                                {!isSystemField(currentFieldData) &&
                                    isAddNewField(currentFieldData) && (
                                        <>
                                            <IconButton
                                                className="itemTools"
                                                onClick={event => {
                                                    setMoreActionPopover(null);
                                                    removeCurrentGUIAddField(props);
                                                }}
                                            >
                                                <img
                                                    src="/assets/image/icon-tabs-delete.svg"
                                                    alt=""
                                                />
                                            </IconButton>

                                            {!props.disableBtnShowMore && (
                                                <IconButton
                                                    className="itemTools itemTools-arrow"
                                                    onClick={e =>
                                                        onCloseFieldExpandMore(
                                                            props,
                                                            currentFieldData
                                                        )
                                                    }
                                                >
                                                    <img
                                                        src="/assets/image/icon-arrow-accordion-gray.svg"
                                                        alt=""
                                                    />
                                                </IconButton>
                                            )}
                                        </>
                                    )}
                            </div>
                        </div>
                    </div>
                </div>
                <FieldIdCommon fieldId={props.currentAddField?.id}/>
                {isDisplayOptionShareField(props?.parentPanelScreen, projectInuseDetail?.id, currentFieldData.affiliationProject, corporationDetail?.rootFlag) && <ShareField {...props} />}
                
                {(props.parentPanelScreen === Constant.FORM_MANAGEMENT_SCREEN.ADD_FORM ||
                    props.parentPanelScreen === Constant.FORM_MANAGEMENT_SCREEN.EDIT_FORM) && (
                    <SettingFormDev {...props} />
                )}
            </li>
        );
    };

    return (
        <>
            {indexAddField === -1 ? (
                <></>
            ) : (
                <>
                    {!isSystemField(currentFieldData) && renderCustomField()}
                </>
            )}
        </>
    );
}
